<div class="position-relative department-autocomplete">
  <div class="input-group" [class.input-group-sm]="size === 'sm'">
    <input #searchInput
           type="text"
           class="form-control border-end-0"
           [class.form-control-sm]="size === 'sm'"
           [id]="id"
           [attr.name]="name"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [(ngModel)]="searchText"
           [ngModelOptions]="standaloneOptions"
           (ngModelChange)="onInputChange()"
           (focus)="onFocus()"
           (blur)="handleBlur()"
           (keydown)="onKeyDown($event)"
           role="combobox"
           aria-autocomplete="list"
           [attr.aria-expanded]="open"
           [attr.aria-controls]="id + '-options'"
           autocomplete="off"/>
    <span class="input-group-text bg-white border-start-0 action-buttons" [class.disabled]="disabled">
      @if (searchText && !disabled) {
        <button
          type="button"
          class="btn-clear p-0 border-0 bg-transparent text-muted me-1"
          (mousedown)="clear($event)"
          title="ล้างข้อมูล"
          aria-label="ล้างข้อมูล">
          <i class="bi bi-x-lg"></i>
        </button>
      }
      <button
        type="button"
        class="btn-toggle p-0 border-0 bg-transparent"
        (mousedown)="toggleOpen($event)"
        [disabled]="disabled"
        tabindex="-1"
        aria-label="แสดงรายการหน่วยงาน">
        @if (loading) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
        } @else {
          <i class="bi bi-caret-down-fill" [class.rotated]="open"></i>
        }
      </button>
    </span>
  </div>

  @if (open) {
    <div class="dropdown-menu show w-100" [id]="id + '-options'" role="listbox" style="margin-top: 1px;">
      @if (loading) {
        <div class="dropdown-item text-muted disabled small d-flex align-items-center justify-content-center py-2">
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          <span>กำลังค้นหา...</span>
        </div>
      } @else if (suggestions.length === 0) {
        <div class="dropdown-item text-muted disabled small text-center py-2">
          ไม่พบข้อมูลหน่วยงาน
        </div>
      } @else {
        @for (item of suggestions; track item.id ?? $index; let i = $index) {
          <button
            type="button"
            class="dropdown-item d-flex align-items-center justify-content-between"
            [class.active]="i === highlightedIndex || isSelected(item)"
            [class.py-1]="size === 'sm'"
            role="option"
            [attr.aria-selected]="isSelected(item)"
            (mousedown)="selectDepartment(item, $event)">
            <span class="department-name">{{ item.nameTh }}</span>
            @if (isSelected(item)) {
              <i class="bi bi-check2 text-primary ms-2"></i>
            }
          </button>
        }
      }
    </div>
  }
</div>
